module.exports = __webpack_public_path__ + "static/media/linkedin.b9021ab2.svg";